import { createFileRoute } from "@tanstack/react-router";
import { HOMOSASSA_BLUE_METAL_STUDY as study } from "@/components/site/case-studies";
import { ProjectStudyPage, projectStudyHead } from "@/components/site/CaseStudy";

export const Route = createFileRoute("/projects/blue-metal-roof-homosassa-fl")({
  head: () => projectStudyHead(study),
  component: Page,
});

function Page() {
  return <ProjectStudyPage study={study} />;
}
